import React from "react";
import Decimal from "decimal.js";
import { TextField as TextField2 } from "@material-ui/core";

const ValidatedAmountField = ({
  valueType,
  row,
  fieldKey,
  mode,
  isUnlimitedWallet,
  walletLimit,
  onUpdate,
  columnNo,
  disabledExtraCheck = false,
  disabled = false,
}) => {
  const field = row[fieldKey]; // e.g., sublimit, perTransactionlimit, etc.
  const fieldValue = field?.value ?? 0;

  const getDisplayValue = () => {
    if (fieldValue === 0) return "";
    if (valueType === 2) return `₹ ${fieldValue}`;
    if (valueType === 1) return `${fieldValue} %`;
    return fieldValue;
  };

  const getPlaceholder = () => {
    return valueType === 1 ? "%" : valueType === 2 ? "₹" : "";
  };

  const isDisabled =
    disabled || mode === 2 || field?.enabled === false || disabledExtraCheck;

  const handleChange = (e) => {
    let raw = e.target.value;
    let cleaned = raw.replace(/[₹% ]/g, "").replace(/[^0-9.]/g, "");

    const dotCount = (cleaned.match(/\./g) || []).length;
    if (dotCount > 1) return;

    if (cleaned.includes(".")) {
      const [intPart, decimalPart] = cleaned.split(".");
      if (intPart.length > 8 || decimalPart.length > 2) return;
    } else {
      if (cleaned.length > 8) return;
    }

    const cleanedDecimal = new Decimal(cleaned || 0);

    // Always restrict % to max 100
    if (valueType === 1 && cleanedDecimal.gt(100)) return;

    // Enforce wallet amount limit only if not unlimited and columnNo is NOT in [2, 3, 6, 7]
    const skipWalletLimitForColumns = [2, 3, 6, 7];
    if (
      valueType === 2 &&
      !isUnlimitedWallet &&
      !skipWalletLimitForColumns.includes(columnNo)
    ) {
      const walletDecimal = new Decimal(walletLimit || 0);
      if (cleanedDecimal.gt(walletDecimal)) return;
    }

    onUpdate(cleaned);
  };

  return (
    <TextField2
      className="reactMDlike-underline"
      value={getDisplayValue()}
      placeholder={getPlaceholder()}
      type="text"
      disabled={isDisabled}
      onChange={handleChange}
      inputProps={{ style: { textAlign: "right" } }}
    />
  );
};

export default ValidatedAmountField;

// import React from "react";
// import Decimal from "decimal.js";
// import { TextField as TextField2 } from "@material-ui/core";

// const ValidatedAmountField = ({
//   valueType,
//   row,
//   fieldKey,
//   mode,
//   isUnlimitedWallet,
//   walletLimit,
//   onUpdate,
//   columnNo,
//   disabledExtraCheck = false,
//   disabled = false,
// }) => {
//   const field = row[fieldKey]; // e.g., sublimit, perTransactionlimit, etc.
//   const fieldValue = field?.value ?? 0;

//   const getDisplayValue = () => {
//     if (fieldValue === 0) return "";
//     if (valueType === 2) return `₹ ${fieldValue}`;
//     if (valueType === 1) return `${fieldValue} %`;
//     return fieldValue;
//   };

//   const getPlaceholder = () => {
//     return valueType === 1 ? "%" : valueType === 2 ? "₹" : "";
//   };

//   const isDisabled =
//     disabled || mode === 2 || field?.enabled === false || disabledExtraCheck;

//   const handleChange = (e) => {
//     let raw = e.target.value;
//     let cleaned = raw.replace(/[₹% ]/g, "").replace(/[^0-9.]/g, "");

//     const dotCount = (cleaned.match(/\./g) || []).length;
//     if (dotCount > 1) return;

//     if (cleaned.includes(".")) {
//       const [intPart, decimalPart] = cleaned.split(".");
//       if (intPart.length > 8 || decimalPart.length > 10) return;
//     } else {
//       if (cleaned.length > 8) return;
//     }

//     const cleanedDecimal = new Decimal(cleaned || 0);

//     if (isUnlimitedWallet === true && valueType !== 2) return;

//     if (isUnlimitedWallet === false) {
//       if (valueType === 2) {
//         const walletDecimal = new Decimal(walletLimit || 0);
//         if (cleanedDecimal.gt(walletDecimal)) return;
//       }

//       if (valueType === 1 && cleanedDecimal.gt(100)) return;
//     }

//     onUpdate(cleaned);
//   };

//   return (
//     <TextField2
//       className="reactMDlike-underline"
//       value={getDisplayValue()}
//       placeholder={getPlaceholder()}
//       type="text"
//       disabled={isDisabled}
//       onChange={handleChange}
//       inputProps={{ style: { textAlign: "right" } }}
//     />
//   );
// };

// export default ValidatedAmountField;
